import { render, staticRenderFns } from "./EditUserPassword.vue?vue&type=template&id=5e364281&scoped=true&"
import script from "./EditUserPassword.vue?vue&type=script&lang=js&"
export * from "./EditUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./EditUserPassword.vue?vue&type=style&index=0&id=5e364281&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e364281",
  null
  
)

export default component.exports